export const QColors = ['gray', 'blue', 'green', 'red', 'yellow', 'orange', 'purple', 'pink'] as const;

export type QColorVariant = typeof QColors[number];
export type QColorRgba = `rgba(${number}, ${number}, ${number}, ${number})`;
